export type WaitlistResult = 'joined' | 'invalid' | 'busy' | 'failed';

export type WaitlistForm = {email: string; consent: boolean; website: string};

// Posts a sign-up to the API. Never throws: every outcome maps to a message.
export async function joinWaitlist(fetcher: typeof fetch, apiUrl: string, form: WaitlistForm): Promise<WaitlistResult> {
  const body: Record<string, unknown> = {email: form.email.trim(), consent: form.consent};
  if (form.website) body.website = form.website;
  try {
    const res = await fetcher(`${apiUrl}/v1/waitlist`, {
      method: 'POST',
      headers: {'content-type': 'application/json'},
      body: JSON.stringify(body),
      // The free API sleeps when idle and can take most of a minute to wake.
      signal: AbortSignal.timeout(75_000),
    });
    if (res.status === 202) return 'joined';
    if (res.status === 400) return 'invalid';
    if (res.status === 429) return 'busy';
    return 'failed';
  } catch {
    return 'failed';
  }
}

export const messages: Record<WaitlistResult | 'sending', string> = {
  sending: 'Sending…',
  joined: "Thanks, you're on the list. We'll email you when your invite is ready.",
  invalid: 'Please check your email address and tick the box to agree.',
  busy: 'Too many attempts from your network. Please try again in a minute.',
  failed: "Something went wrong on our side. Please try again in a moment.",
};
